// // src/components/homepage/BusinessAtGlance.jsx
// import React from "react";
// import { motion } from "framer-motion";
// import modelImage from "../../assets/images/modelImage.png";
// import dashboard from "../../assets/images/dashboard.png";

// const BusinessAtGlance = () => {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 50 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.8, ease: "easeOut" }}
//       viewport={{ once: true }}
//       className="my-8 rounded-xl container mx-4 py-12 px-4 md:px-8"
//     >
//       <div className="flex flex-col md:flex-row items-start gap-8">
//         {/* Left: Model Card */}
//         <motion.div
//           initial={{ opacity: 0, scale: 0.95 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//           viewport={{ once: true }}
//           className="hidden md:block bg-[#FFF9ED]  rounded-xl  p-4 md:p-8 md:p-0 md:px-8 md:pt-8 flex-2 flex justify-center h-full"
//         >
//           <img
//             src={modelImage}
//             alt="Smiling woman with phone"
//             className="w-full max-w-sm object-contain"
//           />
//         </motion.div>

//         {/* Right: Text + Dashboard Card */}
//         <motion.div
//           initial={{ opacity: 0, scale: 0.95 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
//           viewport={{ once: true }}
//           className="bg-[#FFF9ED]  rounded-xl px-6 pt-6 md:px-8 md:pt-8 md:p-0 flex-1 flex flex-col justify-center text-left"
//         >
//           <p className="text-agBlack text-xl mb-2 md:mb-4">
//             SEE YOUR BUSINESS AT A GLANCE
//           </p>
//           <h2 className="text-3xl md:text-5xl font-bold text-agBlack leading-tight mb-6">
//             Track Your Sales <br />
//             and Performance
//           </h2>
//           <p className="text-agLightGray font-light text-sm md:text-lg mb-8">
//             Track total sales, weekly growth, profit summary, and order trends,
//             all from your dashboard. Stay informed. Sell smarter.
//           </p>

//           {/* Dashboard image */}
//           <div className="flex justify-center">
//             <img
//               src={dashboard}
//               alt="Dashboard overview"
//               className="w-60 object-contain"
//             />
//           </div>
//         </motion.div>
//       </div>
//     </motion.div>
//   );
// };

// export default BusinessAtGlance;

// src/components/homepage/BusinessAtGlance.jsx
import React from "react";
import { motion } from "framer-motion";
import modelImage from "../../assets/images/modelImage.png";
import dashboard from "../../assets/images/dashboard.png";

const BusinessAtGlance = () => {
  return (
    <div className="">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
        className=" rounded-xl container mx-auto py-12 px-4 md:px-8"
      >
        <div className="flex flex-col md:flex-row items-stretch gap-8">
          {/* Left: Model Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="hidden md:flex bg-[#FFF9ED] rounded-xl p-0 px-8 pt-8 flex-2 justify-center"
          >
            <img
              src={modelImage}
              alt="Smiling woman with phone"
              className="w-full max-w-sm object-contain"
            />
          </motion.div>

          {/* Right: Text + Dashboard Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-[#FFF9ED] rounded-xl px-6 pt-6 md:px-8 md:pt-8 flex-1 flex flex-col justify-center text-left"
          >
            <p className="text-agBlack text-xl mb-2 md:mb-4">
              SEE YOUR BUSINESS AT A GLANCE
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-agBlack leading-tight mb-6">
              Track Your Sales <br />
              and Performance
            </h2>
            <p className="text-agLightGray font-light text-sm md:text-lg mb-8">
              Track total sales, weekly growth, profit summary, and order
              trends, all from your dashboard. Stay informed. Sell smarter.
            </p>

            {/* Dashboard image */}
            <div className="flex justify-center">
              <img
                src={dashboard}
                alt="Dashboard overview"
                className="w-64 object-contain"
              />
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default BusinessAtGlance;
